var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-steps',{staticClass:"import-steps",attrs:{"active":_vm.active,"align-center":"","finish-status":"success"}},_vm._l((_vm.titles),function(title){return _c('el-step',{key:title,attrs:{"title":title}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }